import { useTranslation } from "react-i18next";
import { TextInput } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { ConfirmDialog } from "../ConfirmDialog";

type Props = {
	visible: boolean;
	firstName: string;
	lastName: string;
	onChangeFirstName: (value: string) => void;
	onChangeLastName: (value: string) => void;
	onDismiss: () => void;
	onConfirm: () => void;
	isLoading?: boolean;
};

export const CMENameConfirmationDialog = ({
	visible,
	firstName,
	lastName,
	onChangeFirstName,
	onChangeLastName,
	onDismiss,
	onConfirm,
	isLoading,
}: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	return (
		<ConfirmDialog
			visible={visible}
			icon="certificate-outline"
			dismissCta={t("common.cancel")}
			confirmCta={t("cme.confirm")}
			dismissCallback={onDismiss}
			confirmCallback={onConfirm}
			confirmCtaLoading={isLoading}
			title={t("cme.confirmYourName")}
			subtitle={t("cme.certificateNameNotice")}
			body=""
			subtitleComponent={
				<Box gap={16}>
					<TextInput
						label={t("cme.firstName")}
						value={firstName}
						autoFocus
						placeholder={t("cme.firstNamePlaceholder")}
						onChangeText={onChangeFirstName}
						mode="outlined"
						disabled={isLoading}
						style={{ backgroundColor: theme.colors.surfaceVariant }}
					/>
					<TextInput
						label={t("cme.lastName")}
						value={lastName}
						placeholder={t("cme.lastNamePlaceholder")}
						onChangeText={onChangeLastName}
						mode="outlined"
						disabled={isLoading}
						style={{ backgroundColor: theme.colors.surfaceVariant }}
					/>
				</Box>
			}
		/>
	);
};
